module.exports = __webpack_public_path__ + "static/media/A1.025b0e4e.mp3";